// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"f390ae06","453":"3f5bda53","606":"3285e1a1","773":"a51b1a38"}[chunkId] + ".chunk.js";
};